import { svcAuth } from '@pressreader/services';

function isUserAuthenticated() {
    return Number(svcAuth.userKey()) > 0;
}

export { isUserAuthenticated };
